import { ComposedChart, Bar, Line, LabelList, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend, CartesianGrid, ReferenceArea } from "recharts";
import { MONTHS, fmtCompact } from "@/lib/format";
import { fmtKpi } from "@/lib/perf";

const scale = (key, k, v) => (v === null || v === undefined ? null : (key === "occupancy" || (k.is_ratio && key !== "gop_margin")) && Math.abs(v) <= 1.5 ? v * 100 : v);

export const PerformanceChart = ({ data, kpiKey, onKpi, keys, month }) => {
  const k = data.kpis[kpiKey];
  if (!k) return null;
  const rows = MONTHS.map((m, i) => ({ name: m, actual: scale(kpiKey, k, k.actual[i]), budget: scale(kpiKey, k, k.budget[i]), ly: scale(kpiKey, k, k.ly[i]), forecast: scale(kpiKey, k, k.forecast[i]) }));
  const money = ["revenue", "gop", "ebitda", "nop", "payroll"].includes(kpiKey);
  const tick = (v) => (money ? fmtCompact(v) : kpiKey === "occupancy" || kpiKey === "gop_margin" ? `${v.toFixed(2)}%` : Math.round(v).toLocaleString("en-US"));
  const fmtTip = (v) => (v === null ? "-" : money ? fmtCompact(v) : kpiKey === "occupancy" || kpiKey === "gop_margin" ? `${v.toFixed(2)}%` : fmtKpi(kpiKey, v, k));
  return (
    <div className="bg-white border border-slate-200 rounded-lg p-4" data-testid="performance-chart">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h3 className="font-heading text-base font-semibold text-slate-900">{k.label} by month — Actual · Budget · LY · Forecast</h3>
        <div className="flex flex-wrap gap-1" data-testid="perf-chart-kpis">
          {keys.map((kk) => (
            <button key={kk} onClick={() => onKpi(kk)} data-testid={`perf-chart-kpi-${kk}`}
              className={`text-[11px] px-2 py-1 rounded-full border transition-colors ${kk === kpiKey ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-600 border-slate-200 hover:border-slate-400"}`}>{data.kpis[kk].label}</button>
          ))}
        </div>
      </div>
      <div className="h-80 mt-3">
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={rows} barGap={2} barCategoryGap="28%" margin={{ top: 16, right: 8, left: 0, bottom: 0 }}>
            <CartesianGrid vertical={false} stroke="#E2E8F0" />
            <XAxis dataKey="name" tick={{ fontSize: 11, fill: "#64748B" }} axisLine={false} tickLine={false} />
            <YAxis tickFormatter={tick} tick={{ fontSize: 10, fill: "#64748B", fontFamily: "JetBrains Mono" }} axisLine={false} tickLine={false} width={64} />
            <Tooltip formatter={fmtTip} contentStyle={{ fontSize: 12, borderRadius: 8, borderColor: "#E2E8F0" }} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <ReferenceArea x1={MONTHS[month - 1]} x2={MONTHS[month - 1]} fill="#059669" fillOpacity={0.08} />
            <Bar dataKey="ly" name={data.ly_label} fill="#CBD5E1" radius={[3, 3, 0, 0]}>
              <LabelList dataKey="ly" position="top" offset={4} formatter={(v) => (v === null || v === undefined ? "" : tick(v).replace(/\s+/g, ""))} style={{ fontSize: 8.5, fill: "#64748B", fontFamily: "JetBrains Mono" }} />
            </Bar>
            <Bar dataKey="budget" name={`Budget ${data.budget_year}`} fill="#2563EB" radius={[3, 3, 0, 0]} />
            <Line type="monotone" dataKey="forecast" name={`Forecast ${data.budget_year}`} stroke="#16A34A" strokeWidth={2} dot={{ r: 2 }} connectNulls />
            <Line type="monotone" dataKey="actual" name={`Actual ${data.budget_year}`} stroke="#0F172A" strokeWidth={2.5} dot={{ r: 3 }} connectNulls={false} />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
